import React, { useContext, useEffect, useState } from 'react'
import { TestContext } from '../../../utils/context'
import styles from '../styles.module.scss'
import _ from 'lodash'
import { getQuestionsFile } from '../../../actions/testing';
import { useDispatch, useSelector } from 'react-redux';
import { openCarousel } from '../../../actions/carousel';
import Loader from "react-loader";


function shuffle(array) {
  return array.sort(() => Math.random() - 0.5);
}

const MatchQuestion = ({visible, question: originalQuestion, setQuestionPassed}) => {
  
  const {addQuestionAnswer, nextQuestion, closeTestHandler, testId, navPanel, finishTest, timeOver} = useContext(TestContext)

  const dispatch = useDispatch()
  const {data: filesData, loading} = useSelector(state => state.testing.files)
  
  useEffect(() => {
    const filesRequested = filesData.hasOwnProperty(originalQuestion.question_id)
    if (originalQuestion.question_id && visible && !filesRequested) dispatch(getQuestionsFile(originalQuestion.question_id))
  }, [visible])

  const [question, setquestion] = useState([])
  const [draggable, setDraggable] = useState(null)

  useEffect(() => {
    if (timeOver) return;
    // const answers = _.shuffle(originalQuestion.answers)
    // setquestion({ ...originalQuestion, answers })
    setquestion(originalQuestion)
  }, [timeOver])

  const files = filesData[originalQuestion.question_id]

  const sendAnswerHandler = async () => {
    const payload = question.answers.map((answer, ind) => ({
      answer_id: answer.id,
      answer_num: ind + 1
    }))
    const success = await addQuestionAnswer(testId, question.question_id, payload)
    if (!success) return;
    setQuestionPassed()
    nextQuestion()
  }

  const onDragStart = (index) => () => {
    setDraggable(index)
  }

  const onDragEnter = (index) => () => {
    const answers = question.answers.filter((quest, i) => i !== draggable)
    answers.splice(index, 0, question.answers[draggable])
    setquestion({ ...question, answers })
    setDraggable(index)
  }

  const onDrop = () => {
    setDraggable(null)
  }

  const renderFile = (file, ind) => (
    <img
      onClick={openCarouselHandler(ind)}
      type={file?.mime}
      src={`data:image/jpeg;base64,${file?.content}`}
      key={file?.name}
      alt={file?.name}
    />
  )

  const openCarouselHandler = (initialSlide) => () => {
    const images = files.map(file => `data:image/jpeg;base64,${file.content}`)
    dispatch(openCarousel({images, initialSlide}))
  }

  const renderAnswer = (answer, index) => (
    <div
      draggable
      onDragStart={onDragStart(index)}
      onDragEnter={onDragEnter(index)}
      style={{opacity: draggable === index ? 0.5 : 1}}
    >
      {answer.answer_text}
    </div>
  )

  return (
    <div style={{display: visible ? 'block' : 'none'}}>
      <div className={styles.matchQuestion}>
        <p className={styles.taskTitle}>{question.question_text}</p>
        <div className={styles.files}>
          {
            loading
              ? <Loader/>
              : !!files?.length && files.map(renderFile)
          }
        </div>
        <div onDrop={onDrop} onDragOver={e => e.preventDefault()}>{question.answers?.map(renderAnswer)}</div>
      
      </div>
      {navPanel}
      <div className={styles.buttonsBlock}>
        <button onClick={sendAnswerHandler}>Ответить</button>
        <button onClick={finishTest}>Завершить</button>
      </div>
    </div>
  )
}

export default MatchQuestion